import React from 'react';
import { useSiteConfig } from '../contexts/SiteConfigContext';

function PrivacyPolicyPage() {
  const { config } = useSiteConfig();
  const owner = config?.legal_owner_name || config?.legal_business_name || 'KREEO';
  const nif = config?.legal_nif || '[NIF pendiente]';
  const address = config?.legal_address || 'Barcelona, España';
  const email = config?.legal_email || config?.contact_email || 'ton@kreeo.es';

  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-testid="privacy-policy-page">
      <h1 className="text-4xl font-light text-[#374963] mb-8">Política de Privacidad</h1>
      <div className="space-y-6 text-[#374963] leading-relaxed">
        <p className="text-sm text-[#73706e]">Última actualización: {new Date().toLocaleDateString('es-ES')}</p>

        <section>
          <h2 className="text-2xl font-semibold mb-3">1. Responsable del tratamiento</h2>
          <p>
            El responsable del tratamiento de los datos personales recogidos a través de este sitio web es <strong>{owner}</strong>,
            con NIF <strong>{nif}</strong>, domicilio en <strong>{address}</strong>, y correo electrónico de contacto <strong>{email}</strong>.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-3">2. Finalidad del tratamiento</h2>
          <p>Los datos personales que nos facilitas se tratan con las siguientes finalidades:</p>
          <ul className="list-disc list-inside mt-2 space-y-1">
            <li>Gestionar y tramitar los pedidos realizados en la tienda.</li>
            <li>Enviar comunicaciones relacionadas con el estado del pedido y la entrega.</li>
            <li>Atender consultas enviadas mediante el formulario de contacto o "Cuéntanos tu Idea".</li>
            <li>Cumplir con las obligaciones legales, fiscales y contables aplicables.</li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-3">3. Base jurídica</h2>
          <p>
            La base legal para el tratamiento es la ejecución del contrato de compraventa (art. 6.1.b RGPD),
            el consentimiento del interesado en formularios de contacto (art. 6.1.a RGPD) y el cumplimiento
            de obligaciones legales (art. 6.1.c RGPD).
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-3">4. Conservación de los datos</h2>
          <p>
            Los datos se conservarán mientras exista la relación comercial y, tras su finalización, durante los plazos
            legalmente establecidos para atender responsabilidades derivadas de la relación (mínimo 5 años según la
            normativa fiscal española).
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-3">5. Destinatarios</h2>
          <p>
            No se cederán datos a terceros salvo obligación legal. Podrán tener acceso proveedores tecnológicos
            que actúen como encargados del tratamiento (hosting, envío de correos y agencia de transporte), siempre
            con las garantías exigidas por el RGPD.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-3">6. Derechos del usuario</h2>
          <p>
            Puedes ejercer en cualquier momento tus derechos de acceso, rectificación, supresión, oposición, limitación
            del tratamiento y portabilidad enviando un correo a <strong>{email}</strong> indicando el derecho que deseas ejercer
            y adjuntando copia de tu DNI o documento identificativo equivalente. Asimismo, tienes derecho a presentar
            una reclamación ante la Agencia Española de Protección de Datos (www.aepd.es).
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-3">7. Seguridad</h2>
          <p>
            {owner} adopta las medidas técnicas y organizativas necesarias para garantizar la seguridad de los datos
            personales y evitar su alteración, pérdida, tratamiento o acceso no autorizado.
          </p>
        </section>
      </div>
    </div>
  );
}

export default PrivacyPolicyPage;
